import { makeStyles } from "@material-ui/core"
import { themeColors } from "letalkui"

export const MENU_LIST_MESSAGE_WIDTH = 336

const useStyles = makeStyles(theme => ({
	showOptionsButton: {
		textTransform: "none",
		fontWeight: "normal",
		fontSize: 14,
		"&:hover": {
			textDecoration: "none"
		}
	},
	dialogContent: {
		padding: theme.spacing(0, 2, 2)
	},
	descriptionContainer: {
		flex: 1,
		textAlign: "left"
	},
	menuItem: {
		height: "auto",
		minHeight: 56,
		textTransform: "none",
		padding: theme.spacing(1.5),
		border: `1px solid ${themeColors.colors.system.gray[200]}`,
		borderRadius: theme.spacing(1)
	},
	menuItemTitle: {
		fontWeight: 600
	},
	menuItemDescription: {
		fontSize: 12,
		opacity: 0.7
	}
}))

export default useStyles
